import { useGetIdentity, usePermissions } from '@pankod/refine-core';
import { useEffect, useState } from 'react';
import { getOfferLimit } from 'services/adminUserService';
import { countOwnedOffers } from 'services/offerService';

export const useOfferLeft = () => {
  const currentUser = useGetIdentity();
  const [offerLeft, setOfferLeft] = useState<number>(0);

  const offerLeftText = offerLeft > 0 ? ` (${offerLeft} left)` : '';

  const reduceOfferLeft = () => {
    setOfferLeft((prev) => Math.max(prev - 1, 0));
  };

  const refresh = async () => {
    const { offerLimit } = await getOfferLimit();
    const offerCount = await countOwnedOffers(
      currentUser.data?.uid || '',
    );
    setOfferLeft(Math.max(offerLimit - offerCount, 0));
  };

  useEffect(() => {
    refresh();
  }, [currentUser.data?.uid]);

  return { offerLeft, offerLeftText, refresh, reduceOfferLeft };
};
